function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createSelector } from 'reselect';
import { getPrepaymentBalance } from 'researcher/user/reducer';
import { price } from 'researcher/helpers/price';
// import { serviceGroup } from 'researcher/domain/product/service-group';
import featureEnabled from 'shared/helper/feature';
import * as c from './constants';
var restrictLanguages = featureEnabled('rubriq_restrict_languages');
export var initialState = {
  adminDomain: '',
  allowedFileTypes: {},
  maxFileSizeInBytes: {},
  allowsAnonymousLanguageAssessment: false,
  allowsDigitalEditing: false,
  allowsDigitalTranslations: false,
  allowsServiceBundles: true,
  companyShortName: null,
  currentLocalization: null,
  localizations: [],
  paddle: {},
  config: {
    allowLanguageSelection: true,
    authenticationProviders: [],
    displayReferralRewardsFlyer: false,
    displayPreprintCampaign: false,
    enforcesDataProtection: false,
    fapiaoAvailable: true,
    fileAlertsForType: {},
    foundUsOptions: [],
    institutionInfoMandatory: true,
    links: {
      customQuote: '/%(language)s/support',
      header: {},
      socialMedia: {},
      qr: {},
      footer: {}
    },
    localAuthEnabled: true,
    captcha: {
      site_key: '1b366dca-3b17-40fd-9c5d-3099e64a500c'
    },
    reeditServiceMap: {},
    referralAmount: 40,
    serviceGroups: [],
    siteLanguages: [],
    upsells: {
      figures: true,
      formatting: true,
      journalRec: true
    },
    // website should have a `default` value, as well as any language-specific overrides
    website: {
      default: ''
    }
  },
  heading: null,
  hideRushRules: [],
  messages: [],
  preferredGroup: null,
  siteLanguage: 'en',
  translations: {},
  translationContext: '',
  status: {
    updatingTranslations: false,
    translationsLoaded: false,
    ready: false
  }
};
export var getServiceGroupsFromConfiguration = function getServiceGroupsFromConfiguration(_ref) {
  var application = _ref.application;
  return (
    // PREMIUM_ADVANCED_EDITING: '236daa23-0d3b-4772-3cb0-cff5eb36d723',
    // ADVANCED_EDITING: '2d1d9a29-de5f-11ea-bf14-0242ac110004',
    application.config.serviceGroups.map(function (serviceGroup) {
      if (serviceGroup.services.indexOf('2d1d9a29-de5f-11ea-bf14-0242ac110004') !== -1) {
        var serviceToRemove = featureEnabled('premiumAdvancedEditing') ? '2d1d9a29-de5f-11ea-bf14-0242ac110004' : '236daa23-0d3b-4772-3cb0-cff5eb36d723';
        return _objectSpread(_objectSpread({}, serviceGroup), {}, {
          services: serviceGroup.services.filter(function (service) {
            return service !== serviceToRemove;
          })
        });
      }
      return serviceGroup;
    })
  );
};
export var getIsDashboardRoute = createSelector(function (_ref2) {
  var location = _ref2.location;
  return location.pathname;
}, function (pathname) {
  return pathname.search(/researcher\/?$/) !== -1;
});
export var getIsOrderFormRoute = createSelector(function (_ref3) {
  var location = _ref3.location;
  return location.pathname;
}, function (pathname) {
  return pathname.search(/submit\//) !== -1;
});
export var getIsCurieRoute = createSelector(function (_ref4) {
  var location = _ref4.location;
  return location.pathname;
}, function (pathname) {
  return pathname.search(/rubriq/) !== -1;
});
export var getIsHomeRoute = createSelector(function (_ref5) {
  var location = _ref5.location;
  return location.pathname;
}, function (pathname) {
  return pathname.search(/home/) !== -1;
});
var getFormattedPrepaymentBalance = createSelector(getPrepaymentBalance, function (_ref6) {
  var user = _ref6.user;
  return user.currency;
}, function (balance, currency) {
  return balance > 0 ? "(".concat(price(currency, balance), ")") : '';
});
var itemIsVisible = function itemIsVisible(item, params) {
  return item.visibleIf ? params[item.visibleIf] : true;
};
var itemIsActive = function itemIsActive(item, currentUrl) {
  return item.url === currentUrl || !!(item.children || []).find(function (childItem) {
    return childItem.url === currentUrl;
  });
};
export var getSubNavItems = createSelector(function (_ref7) {
  var application = _ref7.application;
  return application.config.subNavigation;
}, function (_ref8) {
  var location = _ref8.location;
  return location.pathname;
}, function (_ref9) {
  var user = _ref9.user;
  return !user.hideInvoices;
}, getFormattedPrepaymentBalance, function (_ref10) {
  var user = _ref10.user;
  return user.languageAssessmentEnabled;
}, function (items, pathname, displayInvoices, prepaymentBalance, languageAssessmentEnabled) {
  var params = {
    displayInvoices: displayInvoices,
    languageAssessmentEnabled: languageAssessmentEnabled,
    prepaymentBalance: prepaymentBalance
  };
  var currentUrl = pathname.replace(/\/$/g, '') // Trim right most slash
  .replace(/^\/[a-z]{2}\//, ''); // Trim language

  return items.filter(function (item) {
    return itemIsVisible(item, params);
  }).map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      active: itemIsActive(item, currentUrl),
      params: params,
      children: item.children ? item.children.filter(function (childItem) {
        return itemIsVisible(childItem, params);
      }).map(function (childItem) {
        return _objectSpread(_objectSpread({}, childItem), {}, {
          active: itemIsActive(childItem, currentUrl),
          params: params
        });
      }) : null
    });
  });
});
export var getLocale = createSelector(function (state) {
  return state.application.siteLanguage;
}, function (siteLanguage) {
  switch (siteLanguage) {
    case 'br':
      return {
        iso639Locale: 'pt',
        locale: 'pt_BR'
      };
    case 'cn':
      return {
        iso639Locale: 'zh',
        locale: 'zh_CN'
      };
    case 'es':
      return {
        iso639Locale: 'es',
        locale: 'es_ES'
      };
    case 'jp':
      return {
        iso639Locale: 'ja',
        locale: 'ja_JP'
      };
    default:
      return {
        iso639Locale: 'en',
        locale: 'en_US'
      };
  }
});
export var getProviders = createSelector([function (state) {
  return state.application.siteLanguage;
}, function (state) {
  return state.application.config.authenticationProviders;
}, function (state) {
  return state.application.currentLocalization.identity;
}], function (siteLanguage, providers, currentLocalizationIdentity) {
  return providers.filter(function (provider) {
    return provider.supportedLanguages.indexOf(siteLanguage) !== -1;
  }).filter(function (provider) {
    return provider.supportedLocalizations.indexOf(currentLocalizationIdentity) !== -1;
  });
});
var authenticationProviders = function authenticationProviders() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.config.authenticationProviders;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.CONFIGURATION_LOADED:
      return (action.config.authenticationProviders || []).map(function (provider) {
        return _objectSpread({
          id: '',
          icon: '',
          name: '',
          supportedLanguages: restrictLanguages ? ['cn', 'en'] : ['cn', 'en', 'br', 'es', 'jp']
        }, provider);
      });
    default:
      return state;
  }
};
var serviceGroups = function serviceGroups() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.config.serviceGroups;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.CONFIGURATION_LOADED:
    // return action.config.serviceGroups.map((sg) => serviceGroup(sg));

    default:
      return state;
  }
};
var config = function config() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.config;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.CONFIGURATION_LOADED:
      return _objectSpread(_objectSpread(_objectSpread({}, state), action.config), {}, {
        // Merge application config
        authenticationProviders: authenticationProviders(state.authenticationProviders, action),
        serviceGroups: serviceGroups(state.serviceGroups, action)
      });
    default:
      return state;
  }
};
var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.TRANSLATION_UPDATE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        updatingTranslations: true
      });
    case c.TRANSLATIONS_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        updatingTranslations: false,
        translationsLoaded: true
      });
    case c.APPLICATION_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        ready: true
      });
    default:
      return state;
  }
};
export var applicationReducer = function applicationReducer() {
  var _action$application$m;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.APPLICATION_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        adminDomain: action.application.adminDomain,
        allowedFileTypes: action.application.allowedFileTypes,
        maxFileSizeInBytes: (_action$application$m = action.application.maxFileSizeInBytes) !== null && _action$application$m !== void 0 ? _action$application$m : {},
        allowsAnonymousLanguageAssessment: action.application.allowsAnonymousLanguageAssessment,
        allowsDigitalEditing: action.application.allowsDigitalEditing,
        allowsDigitalTranslations: action.application.allowsDigitalTranslations,
        allowsServiceBundles: action.application.allowsServiceBundles,
        companyShortName: action.application.companyShortName,
        config: config(state.config, action),
        currentLocalization: action.application.currentLocalization,
        hideRushRules: action.application.hideRushRules,
        localizations: action.application.localizations,
        minimumPrepayAmounts: action.application.minimumPrepayAmounts,
        preferredGroup: action.application.preferredGroup,
        status: status(state.status, action),
        paddle: action.application.paddle,
        projectEnvironmentName: action.application.projectEnvironmentName,
        mixpanel: action.application.mixpanel
      });
    case c.CONFIGURATION_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        config: config(state.config, action)
      });
    case c.TRANSLATION_UPDATE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action)
      });
    case c.TRANSLATIONS_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        siteLanguage: action.siteLanguage,
        translationContext: action.translationContext,
        translations: action.translations,
        status: status(state.status, action)
      });
    case c.MESSAGE_DISMISSED:
      return _objectSpread(_objectSpread({}, state), {}, {
        messages: state.messages.filter(function (message) {
          return message.key !== action.key;
        })
      });
    case c.MESSAGE_ADDED:
      return _objectSpread(_objectSpread({}, state), {}, {
        messages: [_objectSpread(_objectSpread({}, action.message), {}, {
          key: action.key
        })]
      });
    case c.HEADING_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        heading: action.heading
      });
    default:
      return state;
  }
};
export default applicationReducer;